import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { ClienteResponse } from 'src/app/api';
import { of, Subject, timer } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap, startWith } from 'rxjs/operators';
import { AuthService } from '../../../services/ajs-auth.service';
import { PerfilService } from '../../../services/ajs-perfil.service';
import { UiRouterState } from '../../../services/ajs-router-state.service';
import { ONE_MINUTE_IN_MILLIS, REFRESH_TIMEOUT } from '../integration-settings/integration-settings.component';
import { ProfilePickupService } from '../../../services/profile/profile-pickup.service';

@Component({
  selector: 'mandae-collection-settings-step',
  templateUrl: './collection-settings.component.html',
  styleUrls: ['./collection-settings.component.scss']
})
export class CollectionSettingsComponent implements OnInit {

  @Input() number = 1;

  @Input() warning = '';
  @Output() warningChange = new EventEmitter<string>();

  @Input()
  public get complete(): boolean {
    return this._complete;
  }
  public set complete(value: boolean) {
    if (this._complete !== value) {
      this._complete = value;
      this.completeChange.emit(value);
    }
  }
  private _complete = false;
  @Output() completeChange = new EventEmitter<boolean>();

  private destroyed = new Subject();

  constructor(
    private auth: AuthService,
    private router: UiRouterState,
    private profilePickupService: ProfilePickupService,
    private profile: PerfilService,
    @Optional() @Inject(REFRESH_TIMEOUT) private readonly refreshTimeout: number,
  ) {
    if (!this.refreshTimeout) {
      this.refreshTimeout = ONE_MINUTE_IN_MILLIS;
    }
  }

  public ngOnInit(): void {
    const user = this.profile.getCacheUserData();

    this.profilePickupService.shouldUpdate
      .pipe(
        startWith({}),
        takeUntil(this.destroyed),
        switchMap(() => this.profilePickupService.getCustomer()
          .pipe(catchError(() => of(null)))
        ),
        map((customerData: ClienteResponse) => customerData && customerData.coletaAtiva),
        tap(complete => this.complete = complete),
      )
      .subscribe();
  }

  public goToCollectionsSettingsPage(): void {
    this.router.go('configuracao-coleta', { showSetupDialog: true }, { reload: true });
  }

}
